const Hopping = ({ className }) => {
  return (
    <div className={`round-icon ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 150 150"
        enableBackground="new 0 0 150 150"
        xmlSpace="preserve"
      >
        <g transform="matrix(-1,0,0,1,150.11019,0)">
          <g>
            <path
              d="M148.23,51.44c-2.58-4.34-5.55-6.43-8.84-6.22c-0.397,0.028-0.792,0.088-1.18,0.18V28.15l-1.83-1
			c-8.737-4.72-18.116-8.14-27.84-10.15c-0.212-4.34-2.013-8.451-5.06-11.55c-3.64-3.61-8.8-5.35-15.28-5.24
			C81.55,0.34,76.42,2.28,73,6c-2.583,2.815-4.104,6.444-4.3,10.26c-11.994,1.818-23.63,5.496-34.49,10.9l-1.83,1v18.1
			c-1.303-0.556-2.688-0.894-4.1-1c-4.33-0.33-8.54,1.53-12.53,5.51l-2.47,2.47l4.939,4.94l2.461-2.47c2.47-2.47,4.83-3.64,7-3.49
			c1.784,0.22,3.438,1.05,4.68,2.35v5.06C13.327,64.779,0.11,82.049,0.11,101.766c0,19.716,13.217,36.984,32.25,42.135v6.22h105.85
			v-96c0.374-0.732,0.907-1.371,1.56-1.87c0,0,0.94,0.27,2.46,2.83L144,58l6-3.57L148.23,51.44z M78.06,10.75
			c2.13-2.27,5.58-3.47,10.26-3.56c5.52-0.09,9.41,1.49,11.53,4.74c0.698,1.087,1.199,2.289,1.48,3.55v0.25
			c-8.482-1.129-17.067-1.264-25.58-0.4C76.075,13.617,76.875,12.03,78.06,10.75z M7.11,101.75c0-14.836,8.937-28.21,22.643-33.888
			c13.706-5.677,29.482-2.538,39.973,7.952s13.629,26.267,7.952,39.973c-5.677,13.706-19.052,22.643-33.888,22.643
			c-20.252-0.021-36.664-16.438-36.68-36.689V101.75z M129.982,142.881L57.72,143.13c21.087-7.079,33.478-28.882,28.769-50.622
			C81.779,70.769,61.475,56.048,39.35,58.33V32.41c9.1-4.26,49.322-21.27,90.632-0.07V142.881z"
            />
          </g>
        </g>
        <path
          stroke="#000000"
          strokeWidth="2"
          strokeMiterlimit="10"
          d="M133.729,100.77c-3.764-4.357-8.791-7.432-14.385-8.794
	c1.566-1.94,2.736-4.168,3.447-6.558l0.195-0.789l-0.636-0.502c-0.423-0.33-10.446-8.064-21.642-6.014
	c-5.069,0.928-9.522,3.719-13.287,8.285c-1.037-0.742-2.684-2.189-2.964-4.087c-0.234-1.597,0.555-3.306,2.346-5.087l-1.776-1.776
	c-2.386,2.374-3.412,4.813-3.032,7.243c0.412,2.748,2.534,4.699,3.909,5.688c-0.501,0.711-0.984,1.449-1.457,2.225
	c-0.398,0.555-2.89,4.131-3.423,9.867c-0.515,5.551,0.789,14.281,9.909,24.368l0.918,1.009l0.928-0.994
	c1.551-1.728,2.977-3.564,4.265-5.496c3.153,4.109,7.397,7.25,12.248,9.067l0.8,0.299l0.572-0.633
	c0.061-0.067,1.379-1.55,2.488-4.62c3.195,1.279,6.602,1.953,10.044,1.99c4.099,0,6.536-1.066,6.707-1.159l0.644-0.291l0.082-0.711
	c0.82-6.924-0.626-12.224-2.183-15.688c3.974-2.73,5.353-5.332,5.413-5.432l0.395-0.757L133.729,100.77z M101.143,80.584
	c8.498-1.564,16.58,3.384,18.958,5.016c-0.903,2.366-2.279,4.523-4.045,6.34c-2.296,2.371-7.229,5.421-13.733,6.427
	c-1.596-4.62-5.922-8.53-12.358-11.086C93.209,83.609,96.951,81.355,101.143,80.584z M96.098,116.22l-0.145,0.234l0,0
	c-1.232,1.962-2.596,3.838-4.08,5.616c-6.043-7.066-8.939-14.385-8.354-21.241c0.455-5.405,2.933-8.69,2.953-8.736l0.082-0.117
	c0.568-0.948,1.162-1.829,1.777-2.645c6.572,2.452,10.791,6.271,11.883,10.755C101.564,105.646,98.739,111.908,96.098,116.22z
	 M111.211,121.43c-0.428,1.512-1.066,2.957-1.897,4.291c-4.341-1.813-8.084-4.806-10.806-8.641c2.609-4.365,5.246-10.447,4.4-16.269
	c2.375-0.378,4.697-1.03,6.92-1.944c1.371,4.252,2.188,8.662,2.428,13.123C112.427,115.172,112.074,118.361,111.211,121.43z
	 M128.25,122.233c-1.756,0.551-6.98,1.692-14.334-1.19c0.637-2.64,0.93-5.351,0.875-8.064c4.033-0.734,7.926-2.1,11.533-4.049
	C127.633,111.954,128.802,116.433,128.25,122.233z M126.207,106.086c-3.149,1.973-7.023,3.434-11.513,4.354
	c-0.368-4.296-1.226-8.535-2.556-12.636c1.916-0.975,3.688-2.208,5.268-3.664c5.304,0.949,10.152,3.605,13.809,7.563
	C129.826,103.457,128.129,104.942,126.207,106.086z"
        />
      </svg>
    </div>
  );
};

export default Hopping;
